/**
 * Stripe Payment Links — the single source of truth for every checkout on the site.
 * Created in the Reach Performance LLC Stripe account. To change a price, edit the
 * product in Stripe; the link stays the same. To swap a link, change it here only.
 */
export const CHECKOUT = {
  // Group memberships — monthly, auto-renew
  advanced1x: 'https://buy.stripe.com/fZu14n7hM0J6elm54N5gc02',
  advanced2x: 'https://buy.stripe.com/aFa00j6dI63qfpq9l35gc01',
  homeschool1x: 'https://buy.stripe.com/fZufZhatYezW9121SB5gc03',
  homeschool2x: 'https://buy.stripe.com/14AbJ17hMezW5OQcxf5gc05',

  // Private 1-on-1 — monthly
  private1x: 'https://buy.stripe.com/00w28r45A2Re5OQeFn5gc09',
  private2x: 'https://buy.stripe.com/28E5kD1Xs8by2CEbtb5gc0a',
  private3x: 'https://buy.stripe.com/6oU3cv0ToezWdhiap75gc0b',

  // Semi-private 2-on-1 — monthly, per athlete
  semi1x: 'https://buy.stripe.com/fZu5kDdGa77ufpq8gZ5gc0c',
  semi2x: 'https://buy.stripe.com/7sYdR97hM63q4KM68R5gc0d',
  semi3x: 'https://buy.stripe.com/7sYdR97hM2Re5OQbtb5gc0e',

  // One-time
  dropIn: 'https://buy.stripe.com/28E7sL7hM1Na5OQdBj5gc04',
  card10: 'https://buy.stripe.com/3cIdR9eKe9fCelm54N5gc06',
  speedSchoolBoth: 'https://buy.stripe.com/28E6oH31w77ua56dBj5gc07',
  speedSchoolSingle: 'https://buy.stripe.com/28E14n7hMfE02CE40J5gc08',
} as const

export const SIBLING_CODE = 'SIBLING10'
export const CANCEL_NOTICE = '14 days'
